import { updateObject } from 'shared/utility';
import * as actionTypes from 'store/actions/actionTypes';

const initialState = {
  sideDrawerOpen: false,
  defaultServer: 'https://api1.riza.network/api/',
  // defaultServer: process.env.NODE_ENV === 'production' ? 'https://api-social.apptazer.com/api/' : 'https://api1.riza.life/api/',
  selectedServer: null,
  servers: [],
  loadingServers: false,
  debugMode: false,
  scrollToTopOfChild: false,
  errorTitle: null,
  errorMessage: null,
  showProfileForm: false,
};

const toggleSideDrawer = (state) => {
  return updateObject(state, {
    sideDrawerOpen: !state.sideDrawerOpen,
  });
};

const getAvailableServersStart = (state) => {
  return updateObject(state, {
    loadingServers: true,
  });
};

const getAvailableServersSuccess = (state, action) => {
  return updateObject(state, {
    servers: action.servers,
    loadingServers: false,
  });
};

const getAvailableServersFailed = (state) => {
  return updateObject(state, {
    loadingServers: false,
  });
};

const setSelectedServer = (state, action) => {
  return updateObject(state, {
    selectedServer: action.server,
  });
};

const updateScrollToTopOfChild = (state, action) => {
  const scrollToTop = action.scrollToTop === true;
  return updateObject(state, {
    scrollToTopOfChild: scrollToTop,
  });
};

const logAppError = (state, action) => {
  if (state.errorMessage === null) {
    return updateObject(state, {
      errorTitle: action.errorTitle,
      errorMessage: action.errorMessage,
    });
  }
  return state;
};

const clearAppError = (state) => {
  return updateObject(state, {
    errorTitle: null,
    errorMessage: null,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE_SIDE_DRAWER:
      return toggleSideDrawer(state, action);
    case actionTypes.GET_AVAILABLE_SERVERS_START:
      return getAvailableServersStart(state, action);
    case actionTypes.GET_AVAILABLE_SERVERS_SUCCESS:
      return getAvailableServersSuccess(state, action);
    case actionTypes.GET_AVAILABLE_SERVERS_FAILED:
      return getAvailableServersFailed(state, action);
    case actionTypes.SET_SELECTED_SERVER_SUCCESS:
      return setSelectedServer(state, action);
    case actionTypes.UPDATE_SCROLL_TO_TOP_OF_CHILD:
      return updateScrollToTopOfChild(state, action);
    case actionTypes.LOG_APP_ERROR:
      return logAppError(state, action);
    case actionTypes.CLEAR_APP_ERROR:
      return clearAppError(state, action);
    default:
      return state;
  }
};
export default reducer;
